import { Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common'
import { NgForm } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-admin-user-form',
  templateUrl: './admin-user-form.component.html',
  styleUrls: ['./admin-user-form.component.scss']
})
export class AdminUserFormComponent implements AfterViewInit {

  public data : any = {};
  public company_uuid : any = null;
  public is_mario
  @ViewChild('f', { static: false }) f : NgForm

  constructor(private http: HttpService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private location: Location) { 
    let access:any = this.http.getAccess();

    if(access.is_mario) {
      this.is_mario = access.is_mario == "1" ? true : false;
    }

    const company_uuid: Observable<string> = this.route.params.pipe(map(p => p['company_uuid']));
    company_uuid.subscribe(val => {
      if(val && val != "null") {
        this.company_uuid = val;
      } else {
        this.company_uuid = null;
      }
    }) 
    
    const user_uuid: Observable<string> = this.route.params.pipe(map(p => p['user_uuid']));
    user_uuid.subscribe(val => {
      if(val) {
        this.initData(val);
      }
    }) 
  }

  initForm() {
    this.data = {status: 1, is_admin : 0, com_uuid: this.company_uuid};
    this.f.resetForm(this.data)
    this.cdr.detectChanges();
  }

  ngAfterViewInit(): void {
    this.initForm();
  }

  async initData(uuid) {
    this.data = await this.http.post("/admin/user/get/detail", {uuid});
  }

  async submit() {
    const y = await this.http.post("/admin/user/update", this.data);

    if (!y['status']) {
      this.http.notify(y['message']);
      return;
    }

    this.location.back();

  }

}
